'use strict';

common.View.create('website::partials.Menu', {
    onDOMLoad() {
        this.initMobileMenu();
    },

    initMobileMenu() {
        let hamburger = $('.hamburger');

        // Unbind and rebind, so we only register one event (this is the only way as of 25-08-2022
        hamburger.on('mousedown', (event) => {
            // Check if the button pressed is the left mouse button
            if (event.button === 0) {
                this.initMobileMenuClick(hamburger);
            }
        });
        hamburger.on('touchstart', () => this.initMobileMenuClick(hamburger));
        hamburger.on('keydown', (clickEvent) =>  this.initMobileMenuClick(hamburger, true));

        window.removeEventListener('mobile-menu-closed', this.menuClosedEvent);
        window.addEventListener('mobile-menu-closed', this.menuClosedEvent);
    },

    initMobileMenuClick(hamburger, usingKeyboard = false)
    {
        // Desktop testing mode only
        if( hamburger.hasClass('is-active') ) {
            return;
        }

        let event = new CustomEvent('mobile-menu-update', {
            bubbles: true,
            detail: {
                open: true,
                usingKeyboard: usingKeyboard,
            },
        });

        window.dispatchEvent(event);

        hamburger.addClass('is-active');
        hamburger.attr('aria-expanded', 'true');
        $('body').addClass('overflow-hidden');

        return false;
    },

    menuClosedEvent() {
        let hamburger = $('.hamburger');

        $('body').removeClass('overflow-hidden');
        hamburger.attr('aria-expanded', 'false');

        setTimeout(() => {
            hamburger.removeClass('is-active');
        }, 350);
    },
});
